import React from 'react';
import { Box, Text } from 'rebass/styled-components';

export const PrivacyNote = () => (
  <Box width="100%">
    <Text color="text.main" fontSize="14px">
      🔒 We take your privacy and security very seriously.{' '}
      <a
        href="https://www.getro.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline' }}
      >
        Learn more
      </a>
      .
    </Text>
  </Box>
);
